<div class="toolbar-container">
  <div class="toolbar-nav">
    <button class="toolbar-button"
            [matTooltip]="'TOOLBAR.PARAMETERS' | translate"
            (click)="openParameterDialog()"
            [matTooltipDisabled]="disableTooltip">
      <i class="far fa-sliders-h"></i>
      <div class="toolbar-text"
           translate="TOOLBAR.PARAMETERS"></div>
    </button>

    <button class="toolbar-button"
            [matTooltip]="'TOOLBAR.STRUCTURE' | translate"
            (click)="openStructureDialog()"
            [matTooltipDisabled]="disableTooltip">
      <i class="far fa-sitemap"></i>
      <div class="toolbar-text"
           translate="TOOLBAR.STRUCTURE"></div>
      <i class="far fa-exclamation-triangle"
         *ngIf="
          problematicSublevels?.problematicSubLevel1Codes?.length ||
          (problematicSublevels?.problematicSubLevel2Codes | keyvalue)?.length
        "></i>
    </button>

    <button class="toolbar-button"
            [matTooltip]="departmentLabel"
            (click)="openDepartmentDialog()"
            [matTooltipDisabled]="disableTooltip">
      <i class="far fa-users"></i>
      <div class="toolbar-text">{{ departmentLabel }}</div>
    </button>

    <button class="toolbar-button"
            [matTooltip]="'TOOLBAR.CLASS' | translate"
            (click)="openClassificationDialog()"
            [matTooltipDisabled]="disableTooltip">
      <i class="far fa-id-card"></i>
      <div class="toolbar-text"
           translate="TOOLBAR.CLASS"></div>
    </button>

    <button *ngIf="settings?.activateInternalFees"
            class="toolbar-button"
            [matTooltip]="'TOOLBAR.INTERNAL_RESOURCES' | translate"
            (click)="openInternalResourcesDialog()"
            [matTooltipDisabled]="disableTooltip">
      <i class="far fa-truck"></i>
      <div class="toolbar-text"
           translate="TOOLBAR.INTERNAL_RESOURCES"></div>
    </button>
  </div>

  <div class="rate-titles">
    <div class="sub-rates">
      {{ "TOOLBAR.INC_RATE" | translate }}
      <div class="rates">{{ currentEstimate?.rate | number: "1.2-2" }}</div>
    </div>

    <div class="sub-rates">
      {{ "TOOLBAR.PLANNED_INC_RATE" | translate }}
      <div class="rates">{{ plannedMarkupRate | number: "1.2-2" }}</div>
    </div>
    <div class="sub-rates">
      {{ "TOOLBAR.FEES_MARGIN" | translate }}
      <div class="rates">
        {{ marginFees | currency: "CAD":"symbol-narrow":"1.2-2":"fr" }}
        <i class="far fa-long-arrow-alt-right"></i>
        {{ marginFeesPerc | percent: "1.2-2" }}
      </div>
    </div>
    <div class="sub-rates">
      {{ "TOOLBAR.TOTAL_MARGIN" | translate }}
      <div class="rates">
        {{ marginFinal | currency: "CAD":"symbol-narrow":"1.2-2":"fr" }}
        <i class="far fa-long-arrow-alt-right"></i>
        {{ marginFinalPerc | percent: "1.2-2" }}
      </div>
    </div>
  </div>
</div>

<div class="pop-modal-container pop-inputs"
     *ngIf="modalIsOpen"
     (click)="closeModal()">
  <div class="pop-modal box-layout"
       (click)="$event.stopPropagation()">
    <div class="pop-modal-header box-layout-child full-width">
      <pop-tabs></pop-tabs>
    </div>
    <div class="pop-modal-body box-layout-child full-width">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
